module.exports = __webpack_public_path__ + "static/hero-75abceb9e381062b5a46ecca4c736d16.jpg";